import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';
import ButtonLinkDiscord from './_buttons/ButtonLinkDiscord';
import ButtonLinkFacebook from './_buttons/ButtonLinkFacebook';
import ButtonLinkGithub from './_buttons/ButtonLinkGithub';
import ButtonLinkGoogle from './_buttons/ButtonLinkGoogle';
import ButtonLinkMicrosoft from './_buttons/ButtonLinkMicrosoft';

export default function S_VIEW__link_social_networks() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);

  return (
    <div className="mt-5 flex flex-col gap-2">
      <h3 className="text-xl">{t(i18n_page_settings_user.tabs.account.social_networks_component.title)}</h3>
      <ButtonLinkGoogle />
      <ButtonLinkMicrosoft />
      <ButtonLinkGithub />
      <ButtonLinkDiscord />
      <ButtonLinkFacebook />
    </div>
  );
}
